const tabletTextAlignmentFieldSchema = {
  type: "string",
  label: "Text Alignment (Mobile)",
  name: "tabletTextAlignment",
  options: ["Left", "Center"],
};

export default tabletTextAlignmentFieldSchema;
